import React, { useState } from "react"
import { Mousewheel } from "swiper"
import Swiper from "swiper"
import { Swiper as Carousel, SwiperSlide } from 'swiper/react'
import './index.scss';
import 'swiper/css';
import 'swiper/css/mousewheel';
import * as Intro from './static'
import imgIntro1 from '../../img/intro_1.png';
import imgIntro2 from '../../img/intro3.png';
import imgIntro3 from '../../img/intro_3.png';
import imgIntro4 from '../../img/intro4.jpg';
import imgIntro5 from '../../img/intro5.png';

console.log('Swiper',Swiper)

const directs =
  [
    { name: 'party', title: 'Party', img: imgIntro1, innertext: Intro.intro1, },
    { name: 'SingStar', title: 'SingStar', img: imgIntro4, innertext: Intro.intro2, },
    { name: 'ClubStar', title: 'ClubStar', img: imgIntro3, innertext: Intro.intro3, },
    { name: 'TaikoStar', title: 'TaikoStar', img: imgIntro5, innertext: Intro.intro4, },
    { name: 'ShootingStar', title: 'ShootingStar', img: imgIntro2, innertext: Intro.intro5, },
  ]

const PageFooter = ({ swiper, activeSlide, setActiveSlide }) => {
  return (
    <div>
      <ul className={'content-wrapper directPage'}>
        {
          directs.map((direct, index) => (<li key={index} onClick={() => {
            swiper?.slideTo(index)
            setActiveSlide(index)
          }} className={`item  ${activeSlide === index ? 'active' : ''}`}>
            <h3>{String(index + 1).padStart(2, '0')}</h3>
            <h4>{direct.title}</h4>
          </li>)
          )}
      </ul>
    </div>
  )
}

const AppDirection = () => {
  const [swiper, setSwiper] = useState(null)
  const [activeSlide, setActiveSlide] = useState(0)

  const handleOnSlideChange = (swiper) => {
    setActiveSlide(swiper.realIndex)
  }



  return (
    <section className="introduce">
      <Carousel
        onSwiper={setSwiper}
        // 区分好垂直滑动和水平滑动container和分页器pagination，避免两者冲突
        className="swiper-app-direction"
        modules={[Mousewheel]}
        nested
        mousewheel={{
          sensitivity: .1,
          forceToAxis: true
        }}
        updateOnWindowResize={true}
        speed={1200}
        slidesPerView={'auto'}
        onSlideChange={handleOnSlideChange}
        onSlideChangeTransitionStart={() => {
          //swiperInstance?.disable()
        }}
        onSlideChangeTransitionEnd={() => {
          //swiperInstance?.enable()
        }}
        preventClicksPropagation
      >
        {
          directs.map((intro, index) => (
            <SwiperSlide key={index} className={'slide'} >
              <div className="int-warpper">
                <div className="left">
                  {intro && intro.innertext.map((item, index) =>
                    <p key={index.toString()}>{item}</p>
                  )}
                </div>
                <div className="right">
                  <img src={intro.img} alt="" />
                </div>
              </div>
            </SwiperSlide>
          ))
        }
      </Carousel>
      <PageFooter {...{ swiper, activeSlide, setActiveSlide }} />
    </section>
  )
}
export default AppDirection
